export const PROFILES = {
    adm: 'Administrador',
    agent: 'Agente'
}

export const PERMISSIONS = {
    DELETE_PERMIT_DOCUMENTS: 'Excluir Documentos de Permissionários',
    PROCESS_TRAMIT: 'Tramitar Processos',
    CREDENTIAL_DOCS: 'Documentos de Cred. de Estac.',
    VIOLATION_APPROVE: 'Deferir Infrações',
    VIOLATION_CANCEL: 'Cancelar Infrações',
    SYSTEM_DENATRAN_QUERIES: 'Consultas DENATRAN em todo o sistema',
    SEND_PERMIT_HOLDERS_TO_DETRAN: 'Envio de Permissionários ao DETRAN',
    CLOSE_BATCHES: 'Fechar Lotes',
    PRINT_FINAL_DECISION: 'Imprimir Decisão Final de Processos',
    VIOLATION_DRIVER_INDICATION: 'Indicação de Condutor de Infração',
    PRINT_BATCHES: 'Impressão de Lotes',
    VIOLATION_PAYMENT_DISCOUNTS: 'Descontos no Pagamento de Infrações',
    BREATHALYZER_MANAGEMENT: 'Gerência de Etilômetros',
    PAYMENT_40_DISCOUNT: 'Descontos de 40% para Pagamento',
    DELETE_PROCESSES: 'Excluir Processos',
    USER_DOCUMENTS: 'Documentos de Usuários',
    BASIC: 'Básico',
    DOCUMENT_COLLECTIONS: 'Recolhimentos de Documentos',
    CONFIRM_FILE_PAYMENTS: 'Confirmar Pagamentos por Arquivos',
    VIEW_ALL_ALERTS: 'Visualização de todos os alertas',
    ANTICIPATE_PENALTY_NOTIFICATIONS: 'Antecipar Notificações de Penalidade',
    DELETE_VIOLATION_DOCUMENTS: 'Excluir Documentos de Infrações',
    EDIT_VIOLATION_VALIDATION: 'Edição na Validação de Infrações',
    ARCHIVE_PROCESSES: 'Arquivar Processos',
    USER_MANAGEMENT: 'Gerência de Usuários',
    REOPEN_PROCESSES: 'Reabrir Processos',
    CARD_VIOLATION_PAYMENT: 'Pagamento de Infrações no Cartão',
    VEHICLE_QUERY: 'Consulta de Veículos',
    IMPORT_VEHICLES: 'Importação de Veículos',
    DELETE_USER_DOCUMENTS: 'Excluir Documentos de Usuários',
    AUDIT_QUERY: 'Consulta de Auditorias',
    PERMIT_DOCUMENTS: 'Documentos de Permissionários',
    CHANGE_NA_NP_DATES: 'Alterar datas de NA e NP',
    AGENT_VIOLATION_QUERY: 'Consulta de Infrações para Agentes',
    CREDENTIAL_CREATION: 'Criação de Credenciais',
    FILL_FINAL_DECISION: 'Preencher Decisão Final de Processos',
    REASSIGN_PROCESSES: 'Reatribuir Processos',
    EQUIPMENT_MANAGEMENT: 'Gerência de Equipamentos',
    VIEW_VIOLATION_AGENT: 'Visualizar Agente das Infrações',
    ADMINISTRATOR: 'Administrador',
    ATTACH_PROCESS_DOCUMENTS: 'Anexar Documentos em Processos',
    MANUAL_PAYMENT_PERMIT: 'Baixa Manual de Pagamento de Perm.',
    PERMIT_CREATION: 'Criação de Permissionários',
    DELETE_CREDENTIAL_DOCS: 'Excluir Documentos de Cred. de Estac.',
    ISSUE_AITS: 'Lavratura de AITs',
    VIOLATION_QUERY: 'Consulta de Infrações',
    DRIVER_QUERY: 'Consulta de Condutores',
    MANUAL_PAYMENT_VIOLATION: 'Baixa Manual de Pagamento de Infração',
    ISSUE_AITS_INPUT: 'Digitação de AITs',
    AGENT_TRACKING: 'Rastreamento de Agentes',
    VIOLATION_DOCUMENTS: 'Documentos de Infrações',
    VIOLATION_VALIDATION: 'Validação de Infrações',
    ISSUE_AITS_VIDEO: 'Lavratura de AITs de Videomonitoramento',
    DELETE_CREDENTIALS: 'Excluir Credenciais',
    PERMIT_REPORTS: 'Relatórios de Permissionários',
    EXPORT_BATCHES: 'Exportação de Lotes',
    PROCESS_ALLOCATION: 'Alocação de Processos',
    VIOLATION_REPORTS: 'Relatórios de Infrações',
    REEXAMINE_PROCESSES: 'Reexaminar Processos',
    FINANCIAL_REPORTS: 'Relatórios Financeiros',
    PROCESS_SERVICE: 'Atendimento de Processos',
    DENATRAN_QUERIES: 'Consultas DENATRAN',
    FORWARD_PROCESSES: 'Encaminhar Processos',
    GENERAL_VIOLATION_QUERY: 'Consulta Geral de Infrações',
    DELETE_PERMIT_HOLDERS: 'Excluir Permissionários',
    CAMERA_MANAGEMENT: 'Gerência de Câmeras',
    PROCESS_CREATION: 'Criação de Processos',
    OPEN_PROCESSES: 'Abrir Processos',
    MANAGEMENT_REPORTS: 'Relatórios Gerenciais',
    VIOLATION_VIEW: 'visualizar_infracoes',
}
